import { get_error_msg } from "@/functions/helpers";
export default {
  methods: {
    handleErrors(
      error,
      TRANSLATE_FIELD,
      FALLBACK_MSG,
      preffix = "",
      suffix = ""
    ) {
      if (error?.response?.status === 500) {
        this.$message.error(FALLBACK_MSG);
        return;
      }
      let msg = get_error_msg(
        error?.response?.data,
        TRANSLATE_FIELD,
        FALLBACK_MSG,
        preffix,
        suffix,
        "object"
      );
      this.$message.error(msg.message);

      if (msg.field && this.errors[msg.field]) {
        this.errors = {
          ...this.errors,
          [msg.field]: [msg.message]
        };
      }
    }
  }
};
